// Explicit height instead of relying on `autoHeight`'s auto-measurement,
// which has a known bug where it reserves stale/incorrect space when
// combined with getRowHeight="auto" inside a horizontally-scrolling wrapper.
export const HEADER_HEIGHT = 42;
export const FOOTER_HEIGHT = 52;
export const ROW_ESTIMATE = 52;
export const MIN_GRID_HEIGHT = 330;
export const MAX_GRID_HEIGHT = 600;
export const PAGE_SIZE = 10;